/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RuntimeResourceUsage = {
  reservedMemoryMib?: number | null | undefined;
  peakMemoryMib?: number | null | undefined;
  memoryPressure?: number | null | undefined;
  oomKilled?: boolean | undefined;
};

/** @internal */
export const RuntimeResourceUsage$inboundSchema: z.ZodType<
  RuntimeResourceUsage,
  z.ZodTypeDef,
  unknown
> = z.object({
  reserved_memory_mib: z.nullable(z.number().int()).optional(),
  peak_memory_mib: z.nullable(z.number()).optional(),
  memory_pressure: z.nullable(z.number()).optional(),
  oom_killed: z.boolean().default(false),
}).transform((v) => {
  return remap$(v, {
    "reserved_memory_mib": "reservedMemoryMib",
    "peak_memory_mib": "peakMemoryMib",
    "memory_pressure": "memoryPressure",
    "oom_killed": "oomKilled",
  });
});
/** @internal */
export type RuntimeResourceUsage$Outbound = {
  reserved_memory_mib?: number | null | undefined;
  peak_memory_mib?: number | null | undefined;
  memory_pressure?: number | null | undefined;
  oom_killed: boolean;
};

/** @internal */
export const RuntimeResourceUsage$outboundSchema: z.ZodType<
  RuntimeResourceUsage$Outbound,
  z.ZodTypeDef,
  RuntimeResourceUsage
> = z.object({
  reservedMemoryMib: z.nullable(z.number().int()).optional(),
  peakMemoryMib: z.nullable(z.number()).optional(),
  memoryPressure: z.nullable(z.number()).optional(),
  oomKilled: z.boolean().default(false),
}).transform((v) => {
  return remap$(v, {
    reservedMemoryMib: "reserved_memory_mib",
    peakMemoryMib: "peak_memory_mib",
    memoryPressure: "memory_pressure",
    oomKilled: "oom_killed",
  });
});

export function runtimeResourceUsageToJSON(
  runtimeResourceUsage: RuntimeResourceUsage,
): string {
  return JSON.stringify(
    RuntimeResourceUsage$outboundSchema.parse(runtimeResourceUsage),
  );
}
export function runtimeResourceUsageFromJSON(
  jsonString: string,
): SafeParseResult<RuntimeResourceUsage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RuntimeResourceUsage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RuntimeResourceUsage' from JSON`,
  );
}
